/*global angular*/

// Admin V2 TOP
import AdminSponsorsController from './admin/sponsors/get/index';
import AdminSponsorController from './admin/sponsors/edit';
import AdminEventsExternalController from './admin/events/external';
import AdminLearningCreateController from './admin/learningTracks/create/controller';
// Admin V2 BOTTOM

import AdminEmployeesComplianceController from './admin/compliance/index';
import AdminDashboardController from './admin/dashboard/index';
import AdminCoursesCourseReview from './admin.courses.course.review';
import AdminEventsEventCertificatesController from '../components/admin/eventManager/event/addCertificates/controller';

import AuthorEvaluationFormsController from './author/evaluationForms/get/controller';
import AuthorEvaluationFormsEvaluationFormController from './author/evaluationForms/view/controller';
import AuthorEvaluationFormsEvaluationFormEditController from './author/evaluationForms/edit/controller';
import AuthorCoursesCourseController from './author/course/index';

export default angular
  .module('app.controllers', [])
  .controller('AdminDashboardController', AdminDashboardController)
  .controller('AdminCoursesCourseReview', AdminCoursesCourseReview)
  .controller('AdminLearningCreateController', AdminLearningCreateController)
  .controller('AdminSponsorsController', AdminSponsorsController)
  .controller('AdminSponsorController', AdminSponsorController)
  .controller('AdminEventsExternalController', AdminEventsExternalController)
  .controller('AdminEventsEventCertificatesController', AdminEventsEventCertificatesController)
  .controller('AdminEmployeesComplianceController', AdminEmployeesComplianceController)
  .controller('AuthorCoursesCourseController', AuthorCoursesCourseController)
  .controller('AuthorEvaluationFormsController', AuthorEvaluationFormsController)
  .controller('AuthorEvaluationFormsEvaluationFormController', AuthorEvaluationFormsEvaluationFormController)
  .controller('AuthorEvaluationFormsEvaluationFormEditController', AuthorEvaluationFormsEvaluationFormEditController)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/index.js